import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionButtonDropdown from "../../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../../Core/Layout/ListLayout";
import Tabs from "../../../../../Components/Tabs";
import ConfigureColumns from "./ConfigureColumns";
import ReportTable from "../../../../../Core/ReportTable/ReportTable";
import ReportSearchFilter from "../../../../../Core/ReportSearchFilter/ReportSearchFilter"
import { useGetFrappeReportQuery } from '../../../../../store/api/reportApi';
import { usePostItemListMutation } from "../../../../../store/api/purchaseorderapi";
import { useGetCompanyQuery } from '../../../../../store/api/companyapi'

const Lpntable = () => {
    const navigate = useNavigate();
    const pageSize = 11;
    const [currentPage, setCurrentPage] = useState(1);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [item_list, setitem_list] = useState([]);
    const [getitem_list_data] = usePostItemListMutation();


    const {
        data: companyData,
        error: companyError,
        isLoading: companyLoading,
        refetch: companyRefetch
    } = useGetCompanyQuery();







    const getItemdata = async (newOffset = 0, searchText = "") => {
        const res = await getitem_list_data({ start: newOffset, search_input: searchText });
        const products = res?.data?.result?.products || [];
        if (newOffset === 0) {
            setitem_list(products);
        } else {
            setitem_list((prev) => [...prev, ...products]);
        }
    };

    useEffect(() => {
        getItemdata();
    }, []);

    const companyOptions = companyData?.result?.map(company => ({
        value: company.name,
        label: company.company_name || company.name,
    })) || [];



    // Initialize filters state with default values
    const getDefaultDate = (daysOffset = 0) => {
        const date = new Date();
        date.setDate(date.getDate() + daysOffset);
        return date.toISOString().split('T')[0];
    };

    const [currentFilters, setCurrentFilters] = useState({
        company: 'Stackerbee',
        from_date: getDefaultDate(-30),
        to_date: getDefaultDate(0),
    });

    const getCleanedFilters = () => {
        const cleaned = { ...currentFilters };

        // Remove empty string values
        Object.keys(cleaned).forEach(key => {
            if (cleaned[key] === '') {
                delete cleaned[key];
            }
        });

        // Always include pagination parameters
      // Always include pagination parameters
        cleaned.start = (currentPage - 1) * pageSize;
        cleaned.page_length = pageSize;

        return cleaned;
    };

    // Use the RTK Query hook with cleaned filters
    const { data, error, isLoading, refetch } = useGetFrappeReportQuery({
        report_name: 'Purchase Analytics',
        filters: getCleanedFilters()
    });

    const handleSaveColumns = (updatedColumns) => {
        setShowColumnConfig(false);
    };

    const filtersConfig = [
        {
            name: 'company',
            label: 'company',
            width: '15%',
            type: 'selectsearch',
            options: companyOptions,
            defaultValue: 'Stackerbee'
        },
        {
            name: 'tree_type',
            label: 'Tree Type',
            width: '12%',
            type: 'select',
            defaultValue: 'Supplier Group',
            options: [
                { value: 'Supplier', label: 'Supplier' },
                { value: 'Item Group', label: 'Item Group' },
                { value: 'Item', label: 'Item' },
                { value: 'Supplier Group', label: 'Supplier Group' },


            ]
        },
        {
            name: 'value_quantity',
            label: 'Value Quantity',
            width: '15%',
            type: 'select',
            defaultValue: 'Value',
            options: [
                { value: 'Value', label: 'Value' },
                { value: 'Item Group', label: 'Item Group' },]
        },
        {
            name: 'doc_type',
            label: 'Doc Type ',
            width: '15%',
            type: 'select',
            defaultValue: 'Purchase Order',
            options: [
                { value: 'Purchase Order', label: 'Purchase Order' },
                { value: 'Purchase Receipt', label: 'Purchase Receipt' },
                { value: 'Purchase Invoice', label: 'Purchase Invoice' },]
        },
        {
            name: 'range',
            label: 'Range',
            width: '15%',
            type: 'select',
            defaultValue: 'Monthly',
            options: [
                { value: 'Weekly', label: 'Weekly' },
                { value: 'Monthly', label: 'Monthly' },
                { value: 'Quarterly', label: 'Quarterly' },
                { value: 'Early', label: 'Early' },
            ]
        },

        { name: 'from_date', label: 'From Date', type: 'date', width: '11.7%', defaultValue: getDefaultDate(-30) },
        { name: 'to_date', label: 'To Date', type: 'date', width: '11.7%', defaultValue: getDefaultDate(0) },
    ];

    const handleFilterNewChange = (newFilters) => {
        setCurrentFilters(prev => ({
            ...prev,
            ...newFilters
        }));
        setCurrentPage(1);
    };

    const handleSearchChange = (name, value) => {
        console.log(`Search in ${name}:`, value);
        if (name === "item_code") {
            getItemdata(0, value);
        }

    };

    const handleView = (id) => {
        navigate(`/outbound/outbound-sales-order-view/`, { state: { salesorder: id } });
    };

    const handleEdit = (id) => {
        navigate(`/outbound/outbound-sales-order-edit/`, { state: { salesorder: id } });
    };

    const handleDelete = (id) => {
        console.log("Delete logic for ID:", id);
    };

    const getColumnWidth = (fieldname) => {
        switch (fieldname) {
            case 'date': return '200px';
            case 'updated_at': return '200px';

            default: return '150px';
        }
    };

    const isSortable = (fieldname) => {
        console.log(fieldname, "fieldname_test");
        const sortableFields = [
            'created_at',
            'updated_at',

            'project',
            'company'
        ];
        return sortableFields.includes(fieldname);
    };

    const getSortFn = (fieldtype, fieldname) => {
        if (fieldtype === 'Datetime') {
            return (a, b) => new Date(a[fieldname]) - new Date(b[fieldname]);
        }
        if (['Float', 'Currency', 'Int'].includes(fieldtype)) {
            return (a, b) => parseFloat(a[fieldname]) - parseFloat(b[fieldname]);
        }
        return undefined;
    };

    const excludedFields = [
        'batch_no',

    ];
    const preferredOrder = [
        'warehouse', 'item_code', 'item_name'
    ];

    const dynamicColumns = useMemo(() => {
        if (!data?.message?.columns) return [];

        const sortedColumns = [...data.message.columns]
            .filter(col => !excludedFields.includes(col.fieldname))
            .sort((a, b) => {
                const indexA = preferredOrder.indexOf(a.fieldname);
                const indexB = preferredOrder.indexOf(b.fieldname);

                if (indexA === -1 && indexB === -1) return 0;
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
            });

        const baseColumns = sortedColumns.map(col => ({
            header: col.label,
            name: col.fieldname,
            accessor: col.fieldname,
            width: getColumnWidth(col.fieldname),
            sortable: isSortable(col.fieldname),
            sortFn: getSortFn(col.fieldtype, col.fieldname),
            fieldtype: col.fieldtype,
            options: col.options
        }));

        // Add SI No column at the start
        const siNoColumn = {
            header: 'SI No',
            name: 'si_no',
            width: '60px',
            sortable: false,
            // Render serial number based on row index
            cellRenderer: (row, rowIndex) => rowIndex + 1,
        };

        return [siNoColumn, ...baseColumns];

    }, [data, currentPage]);

    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel"
        }
    ];

    return (
        <div className="container-fluid mt-3" style={{flexGrow:'1'}}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Report" },
                    { label: "Purchase Report" },
                    { label: "Purchase Analytics" ,style:{color:'#270B79'}}
                ]}
                actionButtons={actionButtons}
            >
                <ReportSearchFilter
                    filtersConfig={filtersConfig}
                    onFilterChange={handleFilterNewChange}
                    onSearchChange={handleSearchChange}
                />

                <ReportTable
                    columns={dynamicColumns}
                    data={data?.message.result || data?.result || []}
                    loading={isLoading}


                    pageSize={pageSize}
                    totalRecords={data?.message?.total}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                    showPagination={true}
                />


            </ListLayout>

            <ConfigureColumns
                show={showColumnConfig}
                onClose={() => setShowColumnConfig(false)}
                onSave={handleSaveColumns}
                initialFields={dynamicColumns}
            />
        </div>
    );
};

export default Lpntable;